import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Modal } from "react-bootstrap";
const SaveAsCustomPopup = ({
  closePopup,
  isFavorite,
  setIsFavorite,
  formulaName,
  setFormulaName,
  formulaNote,
  setFormulaNote,
  saveAsCustomFormula,
}) => {
  return (
    <Modal size="lg" show={true} id="prescription-popup">
      <Modal.Body>
        <>
          <div className="prescription-detail">
            <div className="close-btn">
              <FontAwesomeIcon
                icon={faTimesCircle}
                onClick={() => {
                  closePopup();
                  setFormulaNote("");
                  setFormulaName("");
                }}
              />
            </div>
            <div className="inner-section">
              <div className="row">
                <div className="col-md-12">
                  <h2 className="heading">Save as your Custom Formula</h2>
                  <p className="desc">
                    Save formula(s) under a new name, to be added to your Custom
                    Formula(s).
                  </p>
                </div>
                <div className="col-md-12">
                  <input
                    className="name-input"
                    type="text"
                    value={formulaName}
                    onChange={(e) => setFormulaName(e.target.value)}
                    placeholder="Name Formula Here"
                  />
                </div>
                <div className="col-md-12 mt-1">
                  <textarea
                    className="note-textarea"
                    value={formulaNote}
                    onChange={(e) => setFormulaNote(e.target.value)}
                    placeholder="Enter Formula Note Here"
                    rows="4"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="submit-section d-flex justify-content-end align-items-center mb-3">
            {/* <div className="custom-control custom-checkbox custom-popup mb-3">
              <input
                type="checkbox"
                className="custom-control-input hidden-checkbox"
                id="fav"
                checked={isFavorite}
                onChange={() => setIsFavorite(!isFavorite)}
              />
              <label className="custom-control-label" htmlFor="fav"></label>
            </div>
            <p style={{ color: "white", margin: "0px 10px" }}>Favorite</p> */}
            <button
              disabled={formulaName.length < 1}
              className="btn-orange"
              onClick={() => {
                saveAsCustomFormula();
                closePopup();
              }}
            >
              Save
            </button>
          </div>
        </>
      </Modal.Body>
    </Modal>
  );
};
export default SaveAsCustomPopup;
